import {
    apiRequest,
    skpensiunList,
    skpensiunActive,
    skpensiunInactive
} from "../../../../../services/adapters/kepegawaian/skpensiunService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", skpensiunList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", skpensiunInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", skpensiunActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository